import { createContext } from 'react';

export const initialAppContext = {
    headerHeight: 0,
    navBarExternalBg: false,
    navBarTheme: 'light', // 'light' || 'dark'
};

export default createContext(initialAppContext);
